import axios from "axios";
import { storage } from "../../../helpers"
import { API_URL } from "../../../config";

export const deleteRule = async(id) => {
    const token=storage.getToken();
    try{
        const response = await axios.delete(`${API_URL}/nomenclatures/rules/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
    } catch (error) {
        if (error.response) {
            console.error('API Error Response:', error.response.data);
          } else {
            console.error('API Error:', error.message);
          }
          throw error;
    }
}